import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { environment } from '@env/environment'

@Component({
    selector: 'sb-footer',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './footer.component.html',
    styleUrls: ['footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  @Input() classes: string
  @Input() dark = false
  @Input() mode = 'simple'
  @Input() googlePolicyUseTerms = false

  fullYear: any = new Date().getFullYear()
  version: string = environment.version
  infoReCaptcha: boolean

  constructor() {
  }

  ngOnInit() {
    this.classes = `${this.classes} ${this.dark ? 'footer-dark' : 'footer-light'}`
  }
}
